export const filterZonesByFilterObject = (zones, filtersDataObject) => {
  if (!zones.length) return [];
  let filteredZones = [...zones];
  if (filtersDataObject?.maxHeight) {
    filteredZones = filteredZones.filter(z =>
      z.agl_max
        ? z.agl_max <= +filtersDataObject.maxHeight
        : z.max <= +filtersDataObject.maxHeight
    );
  }
  if (filtersDataObject?.minHeight) {
    filteredZones = filteredZones.filter(z =>
      z.agl_min
        ? z.agl_min >= +filtersDataObject.minHeight
        : z.min >= +filtersDataObject.minHeight
    );
  }
  if (filtersDataObject?.type) {
    const arr = filtersDataObject.type;
    filteredZones = filteredZones.filter(z => arr.includes(z?.type));
  }
  if (filtersDataObject?.name) {
    filteredZones = filteredZones.filter(z =>
      z.name.toLowerCase().includes(filtersDataObject.name.toLowerCase())
    );
  }

  return filteredZones;
};
